<template>
    <div class="views-content--case-studies">
        <banner-generic :data="data.hero"></banner-generic>

        <div class="padding--xl-bottom space--md">
            <div class="container">
                <masonry-wall :items="caseStudiesItems" :ssr-columns="1" :gap="30">
                    <template #default="{ item, index }">
                        <card 
                            :data="item"
                            :theme="theme"
                            :allowPin="data.allowPinItem"
                            :class="index<itemsToShow ? '' : 'hidden'"
                            imageClass="ratio--53-35 object-cover"
                        ></card>
                    </template>
                </masonry-wall>
            </div>
        </div>
        <div class="space-bottom--xl">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="text-center">
                            <div v-if="isLoadMore">
                                <button class="button button--solid-black" @click="fetchMore()">Show More</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- elements -->
        <div v-if="showList">
            <div v-for="element in data.elements" :key="element.id">
                <component :is="element.vueName" :data="element" />
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import { BannerGeneric, Card } from "../components";
import { ElementAccordion, ElementBackgroundImage, ElementContent, ElementImage, ElementCTA, ElementColours, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage, ElementForm} from "../components";

export default {
    name: "v-case-studies",
    components: {
        BannerGeneric,
        Card,
        ElementAccordion,
        ElementBackgroundImage,
        ElementColours,
        ElementContent,
        ElementCTA,
        ElementLinks,
        ElementImages,
        ElementImage,
        ElementProducts,
        ElementSplitSlider,
        ElementTiles,
        ElementVideo,
        ElementPercentage,
        ElementForm
    },
    props: {
        data: {
            type: Object
        }
    },
    data () {
        return {
            theme: 'simple', // theme is passed down to the colorcard component for this page only.
            itemsToShow: 0,
            totalItems: 0,
            caseStudiesItems: [],
            isLoadMore: true,
            showList: true
        }
    },
    methods: {
        fetchMore(){
            let app = this
            let url = (window.location.pathname + '/ajax/').replace('//','/');
            let offset = app.totalItems;
            let itemPerLoad = offset <= 0 ? 9 : 6;

            app.isLoadMore = false;

            axios({
                url: url + '?offset=' + (offset<0 ? 0 : offset) + '&count=' + itemPerLoad,
                method: 'GET',
                responseType: 'json',
                // NOTE: we need "Accept header" to make the webp convertion to work during ajax call
                headers: {
                    'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7'
                }
            }).then((response) => {
                if(response.status === 200){
                    if(response.data.caseStudies.length>0){
                        app.showList = false;
                        app.caseStudiesItems = app.caseStudiesItems.concat(response.data.caseStudies);
                        app.totalItems = app.caseStudiesItems.length
                        app.itemsToShow += itemPerLoad;
                        app.showList = true;
                        app.isLoadMore = true;
                    }else{
                        app.isLoadMore = false;
                    }
                }else{
                    app.isLoadMore = true;
                }
            });
        }
    },
    mounted() {
        let app = this;
        
        app.caseStudiesItems = this.convertItemsObjToArray( app.data.casestudies )
        app.totalItems = app.caseStudiesItems.length

        app.fetchMore();
    }
};
</script>
